import { render, staticRenderFns } from "./ResDetail.vue?vue&type=template&id=f8389e3e&scoped=true&lang=pug"
import script from "./ResDetail.vue?vue&type=script&lang=js"
export * from "./ResDetail.vue?vue&type=script&lang=js"
import style0 from "./ResDetail.vue?vue&type=style&index=0&id=f8389e3e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8389e3e",
  null
  
)

export default component.exports